import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-channels }}\n<MainContentLoading />",{ moduleName: "embercom/templates/apps/app/account/loading.hbs" })